import {App as VueApp} from 'vue'
import {nb_NO} from 'primelocale/js/nb_NO.js'
import {Noir} from '@/prime/prime.theme'

import PrimeVue from 'primevue/config'
import {ConfirmationService, ToastService, DialogService, Tooltip} from 'primevue'

export const primeOptions = {
    locale: nb_NO,
    ripple: true,
    theme: {
        preset: Noir,
        options: {
            darkModeSelector: '.dark'
        }
    }
}

const plugin = {
    install: (app: VueApp) => {
        app.use(PrimeVue, primeOptions)
            .use(ConfirmationService)
            .use(ToastService)
            .use(DialogService)

        app.directive('tooltip', Tooltip)
    }
}

export {plugin}